import {isSet,isEmpty,source} from './utils/common'
export function rateChangeCalc(){
	if(validateRateChangeForm()){
		document.getElementById('spinner').classList.remove('hidden');
		//ajax
		$.ajax({
            url: "/homes/re2/homeloanRateChangeCalc?aj=1",
            type: "POST",
            data: {'homeloanRateChangeCalc' : JSON.stringify(homeloancalc.rateChangeCalc)},
            success: function (data) {
                if(!isEmpty(data)){
                	document.getElementById('spinner').classList.add('hidden');
                	document.getElementById('hl_rate_change_response').classList.remove('opacity_otp');
                	let tenureResp = data['homeLoanRateChangeRevisedTenureCalculatorResponse'];
                	document.getElementById('rc_revised_tenure').innerHTML = tenureResp['revisedTenureInMonths'] + ' Months';
                    document.getElementById('rc_reduction_tenure').innerHTML = tenureResp['reductionInTenure'] + ' Months';
                    let emiResp = data['homeLoanRateChangeRevisedEmiCalculatorResponse'];
                    document.getElementById('rc_revised_emi').innerHTML = '&#8377; ' + emiResp['revisedEmi'];
                    document.getElementById('rc_reduction_emi').innerHTML = '&#8377; ' + emiResp['reductionInEmi'];
                }else{
                	document.getElementById('spinner').classList.add('hidden');
                    document.getElementById('error_message').innerHTML = 'Request not found. Please try again by changing values.';
                    document.getElementById('hc_error_popup').click();
                    return false;
                }
            } 
        });
	}else {
		return false;
	}
}

export function resetRateChangeForm(){
	document.getElementById('rc_loan_amount').value = '';
	document.getElementById('rc_loan_amount_price').innerHTML = '';
	document.getElementById('rc_rate_of_interest').value = '';
	document.getElementById('rc_rate_of_interest_price').innerHTML = '';
	document.getElementById('rc_interest_changes_date').value = '';
	document.getElementById('rc_new_rate_of_interest').value = '';
	document.getElementById('rc_loan_taken_date').value = '';
	document.getElementById('rc_interest_changes_date_text').innerHTML = '';
	document.getElementById('rc_new_rate_of_interest_price').innerHTML = '';
	document.getElementById('rc_loan_taken_date_text').innerHTML = '';
	document.getElementById('rc_loan_tenure_year').value = '';
	document.getElementById('rc_loan_tenure_month').value = '';
	document.getElementById('hl_rate_change_response').classList.add('opacity_otp');
	document.getElementById('rc_revised_tenure').innerHTML = ' Months';
    document.getElementById('rc_reduction_tenure').innerHTML = ' Months';
    document.getElementById('rc_revised_emi').innerHTML = '&#8377; 00.00';
    document.getElementById('rc_reduction_emi').innerHTML = '&#8377; 00.00';
}

export function convertDate(id){
	let dateValue = document.getElementById(id).value;
	let dateText = '';
	if(!isEmpty(dateValue)){
		let date = dateValue.split('-');
		dateText = date[0] + ' ' + getMonth(parseInt(date[1]))+ ' ' + date[2];
		document.getElementById(id+'_text').innerHTML = dateText;
		HomeLoanCalculator.hideError(id+'_error');
	}else {
		document.getElementById(id+'_text').innerHTML = '';
	}
}

function getMonth(mon){
	var month = new Array(12);
	month[1] = "Jan";
	month[2] = "Feb";
	month[3] = "Mar";
	month[4] = "Apr";
	month[5] = "May";
	month[6] = "Jun";
	month[7] = "Jul";
	month[8] = "Aug";
	month[9] = "Sep";
	month[10] = "Oct";
	month[11] = "Nov";
	month[12] = "Dec";

	return month[mon];
}

function validateRateChangeForm(){
	let isEmiFormValid = false;
	//RateChange loan amount check..
	if(isRateChangeLoanAmountValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//RateChange loan tenure year and month check
	if(isRateChangeTenureValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//RateChange rate of interest check
	if(isRateChangeInterestValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//RateChange loan taken date check
	if(isRateChangeLoanTakenDateValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//RateChange interest changed date check
	if(isRateChangeInterestChangedDateValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//RateChange interest changed date check
	if(isRateChangeNewInterestValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	return isEmiFormValid;
}

function isRateChangeLoanAmountValid() {
	let rc_loan_amount = document.getElementById('rc_loan_amount').value;
	let regex = /^[0-9, ]+$/i;
	if(rc_loan_amount.match(regex) && rc_loan_amount !='') {
		HomeLoanCalculator.hideError('rc_loan_amount_error');
		homeloancalc.rateChangeCalc.rc_loan_amount = rc_loan_amount.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid loan amount";
		HomeLoanCalculator.showError('rc_loan_amount_error', msg);
		return false;
	}
}

export function isRateChangeTenureValid() {
	let tenure_year = document.getElementById('rc_loan_tenure_year').value;
	let tenure_month = document.getElementById('rc_loan_tenure_month').value;
	if(tenure_year == '' && tenure_month == ''){
		let msg = "Enter valid loan tenure years or months";
		HomeLoanCalculator.showError('rc_loan_tenure_error', msg);
		return false;
	}else if(tenure_year != '' && tenure_month == ''){
		isRateChangeTenureYearValid(tenure_year);
	}else if(tenure_month != '' && tenure_year == ''){
		isRateChangeTenureMonthValid(tenure_month);
	}else {
		let YearTenure = isRateChangeTenureYearValid(tenure_year);
		let MonthTenure = isRateChangeTenureMonthValid(tenure_month);
		if(YearTenure && MonthTenure){
			HomeLoanCalculator.hideError('rc_loan_tenure_error');
			return true;
		}else if(!YearTenure){
			let msg = "Enter valid loan tenure years";
			HomeLoanCalculator.showError('rc_loan_tenure_error', msg);
		}else if(!MonthTenure){
			let msg = "Enter valid loan tenure months";
			HomeLoanCalculator.showError('rc_loan_tenure_error', msg);
		}
	}
		
}

function isRateChangeTenureYearValid(tenure_year) {
	let regex = /^[0-9, ]+$/i;
	if(tenure_year.match(regex) && tenure_year !='') {
		HomeLoanCalculator.hideError('rc_loan_tenure_error');
		homeloancalc.rateChangeCalc.tenure_year = tenure_year.replace(/,/g, '');
		return true;
	} else {
		document.getElementById('rc_loan_tenure_year').value = '';
		let msg = "Enter valid loan tenure years";
		HomeLoanCalculator.showError('rc_loan_tenure_error', msg);
		return false;
	}
}

function isRateChangeTenureMonthValid(tenure_month) {
	let regex = /^[0-9 ]+$/i;
	if(tenure_month !='' && tenure_month.match(regex) && tenure_month >= 0 && tenure_month < 12) {
		HomeLoanCalculator.hideError('rc_loan_tenure_error');
		homeloancalc.rateChangeCalc.tenure_month = tenure_month;
		return true;
	} else {
		document.getElementById('rc_loan_tenure_month').value = '';
		let msg = "Enter valid loan tenure months";
		HomeLoanCalculator.showError('rc_loan_tenure_error', msg);
		return false;
	}
}

function isRateChangeInterestValid() {
	let rc_rate_of_interest = document.getElementById('rc_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(rc_rate_of_interest.match(regex) && rc_rate_of_interest !='') {
		HomeLoanCalculator.hideError('lt_rate_of_interest_error');
		homeloancalc.rateChangeCalc.rc_rate_of_interest = rc_rate_of_interest;
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('rc_rate_of_interest_error', msg);
		return false;
	}
}

function isRateChangeLoanTakenDateValid() {
	let rc_loan_taken_date = document.getElementById('rc_loan_taken_date').value;
	if(rc_loan_taken_date !='') {
		HomeLoanCalculator.hideError('rc_loan_taken_date_error');
		let date = rc_loan_taken_date.split('-');
		homeloancalc.rateChangeCalc.rc_loan_taken_date = date[2] + '-' + date[1] + '-' + date[0];
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('rc_loan_taken_date_error', msg);
		return false;
	}
}

function isRateChangeInterestChangedDateValid() {
	let rc_interest_changes_date = document.getElementById('rc_interest_changes_date').value;
	if(rc_interest_changes_date !='') {
		HomeLoanCalculator.hideError('rc_interest_changes_date_error');
		let date = rc_interest_changes_date.split('-');
		homeloancalc.rateChangeCalc.rc_interest_changes_date = date[2] + '-' + date[1] + '-' + date[0];
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('rc_interest_changes_date_error', msg);
		return false;
	}
}

function isRateChangeNewInterestValid() {
	let rc_new_rate_of_interest = document.getElementById('rc_new_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(rc_new_rate_of_interest.match(regex) && rc_new_rate_of_interest !='') {
		HomeLoanCalculator.hideError('rc_new_rate_of_interest_error');
		homeloancalc.rateChangeCalc.rc_new_rate_of_interest = rc_new_rate_of_interest;
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('rc_new_rate_of_interest_error', msg);
		return false;
	}
}


